import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable2 from "../../components/customTable/CustomTable2";
import { createMRTColumnHelper } from "material-react-table";
import { partner_registerApi } from "../../app/slices/partner_registerSlice";
import SendIcon from "@mui/icons-material/Send";
import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import Swal from "sweetalert2";
import axios from "axios";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ContentCopy } from "@mui/icons-material"; // Import the copy icon from MUI
// import NameSearchComponent from "../../components/customTable/NameSearchComponent";
// import DateSearchComponent from "../../components/customTable/DateSearchComponent";

// import MultiStepForm from "./MultiStepForm";
import CompleteForm from "./MultiStepForm";
import { IoIosArrowRoundBack } from "react-icons/io";
import EntityRegistrationForm from "./EntityRegistrationForm";
import { useMediaQuery, useTheme } from "@mui/material";
import PartnerFilter from "./PartnerSearch";
import axiosInstance from "../../utils/axiosInstance";
import { useNavigate } from "react-router-dom";

// import SearchIcon from "@mui/icons-material/Search";
// import { Refresh } from "@mui/icons-material";
//

export default function PartnerRegister() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [sendingId, setSendingId] = useState(null);

  // const token = sessionStorage.getItem("token");

  const dispatch = useDispatch();
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const PARTNER_PORTAL_URL = import.meta.env.VITE_PARTNER_PORTAL_URL;
  // console.log("first", PARTNER_PORTAL_URL);

  const roleResponse = useSelector((state) => state.login.login.role);

  const sliceResponse = useSelector(
    (state) => state.partner_register.partner_register.data,
  );
  console.log("sliceResponse: ", sliceResponse);
  const stateLoading = useSelector((state) => state.state.loading);
  const handleBlockPartner = async (_id, isBlocked) => {
    try {
      const url = `/partnerBlockUnblock/${_id}`;
      // const url = `${baseUrl}/partnerBlockUnblock/${_id}`;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };
      const response = await axiosInstance.get(url);
      // const response = await axios.get(url, { headers });

      if (!isBlocked) {
        Swal.fire("Blocked!", "User has been blocked.", "success");
      } else {
        Swal.fire("Unblocked!", "User has been unblocked.", "success");
      }

      // Refresh the user list
      dispatch(partner_registerApi());
    } catch (error) {
      console.error("Error blocking/unblocking the user", error);
      Swal.fire(
        "Error",
        "Could not update the user's status. Please try again.",
        "error",
      );
    }
  };
  const permission = () => {
    if (
      roleResponse?.PartnerAllTransactions?.read === 1 ||
      roleResponse?.PartnerSip?.read === 1 ||
      roleResponse?.PartnerClient?.read === 1 ||
      roleResponse?.PartnerSubPartner?.read === 1 ||
      roleResponse?.PartnerEmployee?.read === 1 ||
      roleResponse?.PartnerProposal?.read === 1 ||
      roleResponse?.PartnerQR?.read === 1
    ) {
      // console.log("High>>>>>>>>>>>>>>>>>");
      return true;
    } else {
      console.log("Low>>>>>>>>>>>>>>>>>");
    }
  };
  const columnHelper = createMRTColumnHelper();
  const columns = [
    // columnHelper.accessor("_id", {
    //   header: "ID",
    //   size: 30,
    //   Cell: (cell) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?._id);
    //       toast.success("copied to clipboard!");
    //     };

    //     return (
    //       <Tooltip title={cell.row.original?._id}>
    //         <IconButton onClick={handleCopy}>
    //           <ContentCopy />
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // }),

    ...(permission()
      ? [
          columnHelper.accessor("View Details", {
            header: "View Details",
            size: 30,
            Cell: (cell) => {
              const currentId = cell.row.original._id;
              const isSending = sendingId === currentId;

              return (
                <Box sx={{ display: "flex" }}>
                  <Button
                    onClick={() => viewDetail(cell.row.original)}
                    variant="contained"
                    sx={{
                      // borderRadius: "8px",
                      fontSize: "10px",
                      // border: "1.5px solid #402867",
                      // lineHeight: "0.5rem",
                    }}
                    disabled={sendingId !== null}
                  >
                    <span
                      style={{
                        marginTop: "4px",
                        color: "white",
                        fontSize: "12px",
                      }}
                    >
                      {isSending ? "Sending..." : "View Detail"}
                    </span>
                  </Button>
                </Box>
              );
            },
          }),
        ]
      : []),
    columnHelper.accessor("name", {
      header: "Name",
      size: 30,
      Cell: (cell) => (
        <Tooltip
          title={
            cell.row.original?.token === "NO Token"
              ? "not-allowed"
              : "login to partner portal"
          }
          arrow
          style={{ textAlign: "center", cursor: "pointer", color: "#4a2a7d" }}
          onClick={() => {
            if (cell.row.original?.token !== "NO Token")
              window.open(
                // `${PARTNER_PORTAL_URL}?token=${cell.row.original?.token}`,
                `https://${cell.row.original?.flag}?token=${cell.row.original?.token}`,
                "_blank",
              );
          }}
        >
          {cell.row.original?.name}
          {/* {cell.row.original?.flag} */}
        </Tooltip>
      ),
    }),

    columnHelper.accessor("email", {
      header: "Email",
      size: 30,
    }),

    columnHelper.accessor("dob", {
      header: "Date of Birth",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.dob}</div>
      ),
    }),
    columnHelper.accessor("Entityname", {
      header: "Entity Name",
      size: 30,
      Cell: (cell) => (
        <Tooltip
          title={
            cell.row.original?.token === "NO Token"
              ? "not-allowed"
              : "login to partner portal"
          }
          arrow
          style={{ textAlign: "center", cursor: "pointer", color: "#4a2a7d" }}
          onClick={() => {
            if (cell.row.original?.token !== "NO Token")
              window.open(
                // `${PARTNER_PORTAL_URL}?token=${cell.row.original?.token}`,
                `https://${cell.row.original?.flag}?token=${cell.row.original?.token}`,
                "_blank",
              );
          }}
        >
          {cell.row.original?.Entityname}
        </Tooltip>
      ),
    }),

    columnHelper.accessor("Entityemail", {
      header: "Entity Email",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.Entityemail}
        </div>
      ),
    }),
    columnHelper.accessor("EntityidentificationNo", {
      header: "EntityIdentificationNo",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.EntityidentificationNo}
        </div>
      ),
    }),

    columnHelper.accessor("EntityType", {
      header: "Entity Type",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.EntityType}
        </div>
      ),
    }),
    columnHelper.accessor("Gstin", {
      header: "GSTIN",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.Gstin}</div>
      ),
    }),

    columnHelper.accessor("accHoldername", {
      header: "Account Holder Name",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.accHoldername}
        </div>
      ),
    }),
    columnHelper.accessor("userName", {
      header: "User Name",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.userName}</div>
      ),
    }),
    columnHelper.accessor("mobileNo", {
      header: "Mobile Number",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.mobileNo}</div>
      ),
    }),
    columnHelper.accessor("accNo", {
      header: "Account Number",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.accNo}</div>
      ),
    }),
    columnHelper.accessor("Ifsccode", {
      header: "IFSC Code",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.Ifsccode}</div>
      ),
    }),
    columnHelper.accessor("aadharNo", {
      header: "Aadhar Number",
      size: 30,
    }),
    columnHelper.accessor("Address", {
      header: "Address",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.Address}</div>
      ),
    }),
    columnHelper.accessor("city", {
      header: "City",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.city}</div>
      ),
    }),
    columnHelper.accessor("state", {
      header: "State",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.state}</div>
      ),
    }),
    columnHelper.accessor("panNo", {
      header: "PAN Number",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>{cell.row.original?.panNo}</div>
      ),
    }),

    columnHelper.accessor("registerType", {
      header: "Register Type",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.registerType}
        </div>
      ),
    }),
    columnHelper.accessor("commission_per", {
      header: "Commission Percentage",
      size: 300,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.commission_per}
        </div>
      ),
    }),
    columnHelper.accessor("mmtc_commission_per", {
      header: "MMTC Commission Percentage",
      size: 300,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.mmtc_commission_per}
        </div>
      ),
    }),

    columnHelper.accessor("is_deleted", {
      header: "Is Deleted",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original?.is_deleted}
        </div>
      ),
    }),

    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {cell.row.original.createdAt?.split("T")[0]}
        </div>
      ),
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      Cell: (cell) => (
        <div style={{ textAlign: "center" }}>
          {" "}
          {cell.row.original.updatedAt?.split("T")[0]}{" "}
        </div>
      ),
      size: 30,
    }),
  ];

  if (roleResponse?.PartnerRegisterations?.update === 1) {
    columns.push(
      columnHelper.accessor("action", {
        header: "Action",
        size: 400,
        Cell: (cell) =>
          roleResponse?.PartnerRegisterations?.update === 1 && (
            <>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Box
                //  sx={{ display: "flex" }}
                >
                  {/* <IconButton onClick={() => openEditModal(row.original)}> */}
                  <Button
                    onClick={() => handleOpen(cell.row.original)}
                    variant="contained"
                    sx={{ fontSize: "12px" }}
                  >
                    Update commission
                    {/* <EditIcon color="#4d16a4" /> */}
                  </Button>
                </Box>
                <Box key={cell.row.original._id}>
                  <Button
                    onClick={() => {
                      Swal.fire({
                        title: "Are you sure?",
                        text: `Are you sure you want to ${
                          cell.row.original.isBlocked ? "unblock" : "block"
                        } this partner?`,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: cell.row.original.isBlocked
                          ? "Unblock"
                          : "Block",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          handleBlockPartner(
                            cell.row.original._id,
                            cell.row.original.isBlocked,
                          );
                        }
                      });
                    }}
                    style={{
                      // backgroundColor: "rgb(74 42 125)",
                      backgroundColor:
                        cell.row.original.isBlocked == true
                          ? "red"
                          : "rgb(74 42 125)",
                      // width: "8rem",
                      padding: "7px 14px",
                      // borderRadius: "12px",
                      // fontSize: "13px",
                      fontSize: "12px",
                      color: "white",
                    }}
                  >
                    {cell.row.original.isBlocked
                      ? "Unblock Partner"
                      : "Block Partner"}
                  </Button>
                </Box>
              </Box>
            </>
          ),
      }),
    );
  }

  const viewDetail = (data) => {
    navigate(`/view_detail/${data._id}?partnerUsername=${data.userName}`, {
      state: {
        name: data?.name || data?.Entityname,
        userName: data?.userName,
        mobileNo: data?.mobileNo,
        email: data?.email || data?.Entityemail,
        commsion_per: data?.commission_per,
        mmtc_commission_per: data?.mmtc_commission_per,
      },
    });
  };
  const handleResendEmail = async (id) => {
    if (sendingId === id) return;
    if (sendingId !== null) return;

    try {
      setSendingId(id);
      const url = `/commission/mailresent/${id}`;
      // const url = `${baseUrl}/commission/mailresent/${id}`;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };

      const response = await axiosInstance.post(url, {});
      // const response = await axios.post(url, {}, { headers });
      // console.log("Response from resend email:", response);
      if (response?.data?.error === false) {
        Swal.fire({
          text: response?.data?.message || "Operation completed successfully.",
          icon: "success",
          timer: 3000,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          text: response?.data?.message || "something went wrong !",
          icon: "error",
          timer: 3000,
          showConfirmButton: false,
        });
      }
      dispatch(partner_registerApi({}));
    } catch (error) {
      console.error("Error in handleResendEmail:", error);
      Swal.fire({
        text: error?.response?.data?.message,
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setSendingId(null);
    }
  };

  columns.push(
    columnHelper.accessor("resendMail", {
      header: "Resend Mail",
      size: 10,
      Cell: (cell) => {
        const currentId = cell.row.original._id;
        const isSending = sendingId === currentId;

        return (
          <Box sx={{ display: "flex" }}>
            <Button
              onClick={() => handleResendEmail(currentId)}
              variant="contained"
              sx={{ fontSize: "10px" }}
              startIcon={
                isSending ? (
                  <CircularProgress size={10} sx={{ color: "white" }} />
                ) : (
                  <SendIcon sx={{ color: "white !important" }} />
                )
              }
              disabled={sendingId !== null}
            >
              <span
                style={{ marginTop: "4px", color: "white", fontSize: "12px" }}
              >
                {isSending ? "Sending..." : "Resend Mail"}
              </span>
            </Button>
          </Box>
        );
      },
    }),
  );

  const [searchTerm, setSearchTerm] = useState(""); // For name search
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  }); // For date search

  useEffect(() => {
    if (searchTerm) {
      // If searchTerm is provided, search by name
      dispatch(partner_registerApi({ name: searchTerm }));
    } else if (queryParams.startDate && queryParams.endDate) {
      // If startDate and endDate are provided, search by date range
      dispatch(partner_registerApi(queryParams));
    } else {
      // Default API call without filters
      dispatch(partner_registerApi({}));
    }
  }, [dispatch, searchTerm, queryParams]);

  const handleSearchByDate = (startDate, endDate) => {
    setSearchTerm(""); // Clear name search when using date search
    setQueryParams({ startDate, endDate });
  };

  const [showForm, setShowForm] = useState(true);
  const formShowHandler = (e) => {
    e.preventDefault();
    setShowForm(false);
  };
  const [activeTab, setActiveTab] = useState("Individual Partner");

  const [selectedRow, setselectedRow] = useState("");
  // console.log("selectedRow: ", selectedRow);

  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const handleOpen = (data) => {
    setselectedRow(data);
    setOpen(true);
  };
  const [formData, setFormData] = useState({
    commission: "",
    mmtc_commission: "",
  });
  console.log("formData: ", formData);
  useEffect(() => {
    if (selectedRow) {
      setFormData({
        commission: selectedRow.commission_per || "",
        mmtc_commission: selectedRow.mmtc_commission_per || "",
      });
    }
  }, [selectedRow]);
  //   const handleChange = (e) => {
  //     // setFormData(e.target.value);
  //     const { name, value } = e.target;
  // setFormData({...formData, name, value});
  //     // Basic validation example
  //   };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Clear error if value is valid
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const url = `/commision/update/${selectedRow._id}`;
      // const url = `${baseUrl}/commision/update/${selectedRow._id}`;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };

      const response = await axiosInstance.post(url, formData);
      // const response = await axios.post(url, formData, { headers });
      Swal.fire({
        // text: response.data.message,
        text: "Batuk partner commission updated successfully",
        icon: "success",
        timer: 3000,
        showConfirmButton: false,
      });
      setLoading(false);
      dispatch(partner_registerApi({}));
      setFormData({ commission: "", mmtc_commission: "" });

      // toast.success("User updated successfully");
      handleClose();
    } catch (error) {
      console.error("Error updating user:", error);
      // toast.error("Error updating user");
      handleClose();
    }
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ✅ Mobile screen check

  return (
    <>
      {/*  */}

      {showForm && roleResponse?.Notification?.write === 1 && (
        <Grid item xs={12} md={6} lg={3} sx={{ mb: 2 }}>
          <Button
            onClick={formShowHandler}
            variant="contained"
            sx={{
              backgroundColor: "#4a2a7d",
              color: "white !important",
              "&:hover": {
                backgroundColor: "#4a2a7d",
              },
            }}
          >
            Create Partner +
          </Button>
        </Grid>
      )}
      {!showForm && (
        <Card>
          <IconButton onClick={() => setShowForm(true)}>
            <IoIosArrowRoundBack />
          </IconButton>
          <CardContent sx={{ mb: 3 }}>
            <Box sx={{ mb: 4 }}>
              <Box>
                {/* Buttons to switch between Role and Employee views */}
                <Box display="flex" justifyContent="center" mb={2}>
                  <Button
                    variant={
                      activeTab === "Individual Partner"
                        ? "contained"
                        : "outlined"
                    }
                    onClick={() => setActiveTab("Individual Partner")}
                    sx={{ marginRight: 2 }}
                  >
                    Individual Partner
                  </Button>
                  <Button
                    variant={
                      activeTab === "Entity Partner" ? "contained" : "outlined"
                    }
                    onClick={() => setActiveTab("Entity Partner")}
                  >
                    Entity Partner
                  </Button>
                </Box>

                {/* Conditionally render content based on activeTab */}
                {activeTab === "Individual Partner" && (
                  <div>
                    <CompleteForm setShowForm={setShowForm} />{" "}
                  </div>
                )}

                {activeTab === "Entity Partner" && (
                  <div>
                    <EntityRegistrationForm setShowForm={setShowForm} />
                  </div>
                )}
              </Box>
            </Box>
          </CardContent>
        </Card>
      )}

      {/* Passing the search handler */}
      {showForm && (
        <>
          <Box>
            {/* <Box
              display="flex"
              flexDirection={isMobile ? "column" : "row"}
              alignItems={isMobile ? "stretch" : "center"}
              justifyContent={isMobile ? "flex-start" : "space-between"}
              mb={2}
            >
              <Box width={isMobile ? "100%" : "40%"}>
                <NameSearchComponent
                  onSearch={(name) => {
                    setQueryParams({ startDate: null, endDate: null });
                    setSearchTerm(name);
                  }}
                                placeholderName="Search by Name or Partner code"

                />
              </Box>
              <Box
                width={isMobile ? "100%" : "55%"}
                mt={isMobile ? 2 : 0}
                ml={isMobile ? 0 : 0}
              >
                <DateSearchComponent onSearch={handleSearchByDate} />
              </Box>
            </Box> */}

            <PartnerFilter />

            {/* <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "wrap",
                p: 0,
                mb: 2,
              }}
            >
              <FormControl sx={{ minWidth: 250 }}>
                <InputLabel>Filter By</InputLabel>
                <Select
                  size="small"
                  value={selectedFilter}
                  label="Filter By"
                  onChange={(e) => setSelectedFilter(e.target.value)}
                >
                  {filterOptions.map((opt) => (
                    <MenuItem key={opt} value={opt}>
                      {opt}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {selectedFilter && selectedFilter !== "Date" && (
                <TextField
                  type={selectedFilter === "Mobile" ? "tel" : "text"}
                  size="small"
                  label={`Enter ${selectedFilter}`}
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  sx={{ minWidth: 250 }}
                />
              )}

              {selectedFilter === "Date" && (
                <>
                  <TextField
                    size="small"
                    type="date"
                    label="Start Date"
                    InputLabelProps={{ shrink: true }}
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />

                  <TextField
                    size="small"
                    type="date"
                    label="End Date"
                    InputLabelProps={{ shrink: true }}
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </>
              )}

              <Box>

                <IconButton
                  color="primary"
                  onClick={handleSearch}
                >
                  <SearchIcon />
                </IconButton>

                <IconButton
                  color="error"
                  onClick={handleReset}
                >
                  <Refresh />
                </IconButton>
              </Box>
            </Box> */}

            <CustomTable2
              columns={columns}
              data={sliceResponse}
              loading={stateLoading}
              permissionKey="PartnerRegisterations"
            />
          </Box>
        </>
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            // border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" component="h2">
            ID : {selectedRow._id}{" "}
          </Typography>
          <Typography variant="h6" component="h2">
            Name : {selectedRow.name || selectedRow.Entityname}{" "}
          </Typography>

          <form onSubmit={handleSubmit}>
            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="Commission"
                  // name="commission"
                  name="commission"
                  value={formData.commission}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="mmtc commission"
                  name="mmtc_commission"
                  value={formData.mmtc_commission}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleClose}
                >
                  Back
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  style={{ float: "right", position: "relative" }}
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress
                      size={25}
                      value={75}
                      sx={{ color: "white" }}
                    />
                  ) : (
                    "Update"
                  )}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>
    </>
  );
}
